import "./OvenMaintenanceRiyadh.module.css";
import Header from "@/reusable_sections/Header";
import OvenRepairHero from "./sections/OvenRepairHero";
import OvenMaintenanceServiceOverview from "./sections/OvenMaintenanceServiceOverview";
import Footer from "@/reusable_sections/Footer";
export default function OvenMaintenanceRiyadhPage() {
  return <div>
      <Header />
      <OvenRepairHero />
      <OvenMaintenanceServiceOverview />
      <Footer />
    </div>;
}